export default {
  en: {
    labelHorarioCurso: "Schedule for course",
    labelHorarioDisciplina: "Schedule for curricular unit",
    labelHorarioSala: "Schedule for classroom",
    labelHorarioAvalCurso: "Schedule for assessments of course",
    labelHorarioAvalDisciplina: "Schedule for assessments of curricular unit",
    labelHorarioDocente: "Schedule for Professor",
    imprimirhorario: "Print Schedule",
    addcalendar:"Add Calendar",
    cursodisciplina: 'Courses',
    curso: 'Courses',
    sala: "Classroom",
    avaliacao: "Assessments",
    docente: "Professor",
    pesquisa: "Schedule Search",
    forms:{
      ciclo: "Cycle",
      curso: "Course",
      ano: "Year",
      disciplina: "Subject",
      turma: "Class",
      sala: "Classroom",
      docente: "Professor",
      data: "Date",
      avaliacao: "Assessments"
    },
    atualiza: "Updating search options",
    errors:{
      select: 'Is is not possible to select {formatedErrors} because there are no options available for the choosen dates',
      selectp: 'Is is not possible to select {formatedErrors} because there are no options available for the choosen dates',
      obrigatorio: "Warning: The field {formatedErrors} is required",
      obrigatorios: "Warning: The fields {formatedErrors} is required",
    },
    selectoptions: "Choose one of the options",
    pesquisar: "Search Schedule",
    hoje: "Today",
    apesquisarhorario: "Searching Schedule",
    edit:"Edit",
    semeventos: "There is no events for this day",
    consultarcalendario:"View Calendar",
    datapesquisa: "Choose date to search",
    back: "Back",
    avaliacaoItem: "Assessment",
    ano: "Year",
    semavaliacao: "There are no assessments available for this month",
    pesquisarword: "Search",
    piso: "Floor"
  },
  pt: {
    labelHorarioCurso: "Horário do curso",
    labelHorarioDisciplina: "Horário da disciplina",
    labelHorarioSala: "Horário do sala",
    labelHorarioAvalCurso: "Horário da avaliação do curso",
    labelHorarioAvalDisciplina: "Horário da avaliação da disciplina",
    labelHorarioDocente: "Horário do docente",
    imprimirhorario: "Imprimir Horário",
    addcalendar:"Adicionar Calendário",
    cursodisciplina: "Curso/Disciplina",
    curso: "Curso/Disciplina",
    sala: "Sala",
    avaliacao: "Avaliação",
    docente: "Docente",
    pesquisa: "Pesquisa de Horários",
    forms:{
      ciclo: "Ciclo",
      curso: "Curso",
      ano: "Ano",
      disciplina: "Disciplina",
      turma: "Turma",
      sala: "Sala",
      docente: "Docente",
      data: "Data",
      avaliacao: "Avaliação"
    },
    atualiza: "A atualizar opções de pesquisa",
    errors:{
      select: 'Não é possível seleccionar o campo {formatedErrors} pelo facto de não existirem opções disponíveis para esta data',
      selectp: 'Não é possível seleccionar os campos {formatedErrors} pelo facto de não existirem opções disponíveis para esta data',
      obrigatorio: "Atenção: O campo {formatedErrors} é de preenchimento obrigatório",
      obrigatorios: "Atenção: Os campos {formatedErrors} são de preenchimento obrigatório",
    },
    selectoptions: "Selecione uma das opções",
    pesquisar: "Pesquisar Horário",
    hoje: "Hoje",
    apesquisarhorario:"A pesquisar horário",
    edit:"Editar",
    semeventos: "Sem eventos para este dia",
    consultarcalendario: "Consultar Calendário",
    datapesquisa: "Selecione a data de pesquisa",
    back: "Anterior",
    avaliacaoItem: "Avaliação",
    ano: "Ano",
    semavaliacao: "Não existem avaliações neste mês",
    pesquisarword: "Pesquisar",
    piso: "Piso"
  }
}